export default "__VITE_ASSET__e578ff87__"